import type { ExportedGlobalComposer } from 'vue-i18n'

export const useTranslation = () => {
  const { vueApp: { config: { globalProperties } } } = useNuxtApp()

  /**
   * Locale message translation
   *
   * @remarks
   * About details functions, See the {@link VueI18nTranslation}
   */
  const t = (key: string, value?: any) => globalProperties.$t(key, value)

  /**
   * Checks if translation key exists
   *
   * @param key
   * @param locale
   *
   * @remarks About function details, see {@link https://kazupon.github.io/vue-i18n/api/#te}
   */
  const te = (key: string, locale?: string) => globalProperties.$te(key, locale)
  const locale = globalProperties.$i18n.locale

  return {
    i18n: globalProperties.$i18n as ExportedGlobalComposer,
    t,
    te,
    locale,
  }
}
